$(document).ready(function () {
  $(".diagram-facet-node .node-title").click(function () {
    var node = $(this).closest(".diagram-facet-node");
    var hasOpen = node.attr("open");
    if (typeof hasOpen === "undefined" || hasOpen === false) {
      node.attr("open", "");
    } else {
      node.removeAttr("open");
    }
  });
  $(".diagram-image").click(function () {
    if ($(window).width() > 800) {
      $("#diagram-image-popup").attr("open", "");
    } else {
      window.open($("#diagram-image-popup img").attr("src"), "_blank");
    }
  });
});
